import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./guideToolTip.scss";

export interface IToolTip {
    readonly contentHeading?: string;
    readonly tooltipNo?: string;
    readonly content?: string;
    readonly cancelClick?: () => void;
    readonly buttonName?: string;
    readonly buttonOnClick?: () => void;
    readonly customButtonStyle?: string;
}

function GuideToolTip({
    contentHeading,
    tooltipNo,
    content,
    cancelClick,
    buttonOnClick,
    buttonName,
    customButtonStyle,
}: IToolTip) {
    const tooltipRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
                cancelClick?.();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [cancelClick]);

    return (
        <div className="guide-tooltip-arrow" ref={tooltipRef}>
            <div className="guide-tooltip-container">
                <button type="button" className="guide-tooltip-icon" onClick={() => {
                    cancelClick?.();
                }} aria-label="Close guide tooltip">
                    <FontAwesomeIcon icon={regular("xmark")} />
                </button>
                <div className="guide-tooltip-top-layer">
                    <div className="guide-tooltip-heading">{contentHeading}</div>
                </div>
                <div className="guide-tooltip-bottom-layer">
                    <div className="guide-tooltip-number">{tooltipNo}</div>
                    <div className="guide-tooltip-content">{content}</div>
                    {buttonName && <div className="guide-tooltip-button"><button type="button" onClick={() => { buttonOnClick?.() }} className={customButtonStyle}> {buttonName}</button></div>}
                </div>
            </div>
        </div>
    );
}

export default GuideToolTip;
